// URL-safe slug from a title.
// Ex: "Ojo Que VolvÍ" -> "ojo-que-volvi"
export const slugify = (title) => {
  if (!title) return '';
  return String(title)
    .normalize('NFD')                        // split accents from letters
    .replace(/[\u0300-\u036f]/g, '')         // drop accent marks
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')             // non-alphanumeric -> dash
    .replace(/^-+|-+$/g, '')                 // trim leading/trailing dashes
    .slice(0, 80);
};
